// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"d56f60ab","616":"54a73769"}[chunkId] + ".chunk.js";
};